export default {
    DISABLE_SAVE_SEARCH_FLY(state) {
        state.isSavedSearchFlyEnabled = false;
    },
};
